<script>
import { formatDate } from '@lib/utils/format-date'
import OfferMixin from '../../../offer/offer.mixin'
import PreviewModal from './preview-modal'
import OfferCoupon from './offers/offer-coupon'
import OfferShow from './offers/offer-show'

export default {
  name: 'RetailerOffer',
  components: {
    PreviewModal,
    OfferCoupon,
    OfferShow,
  },
  mixins: [OfferMixin],
  props: {
    offer: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      termsVisible: false,
      offerVisible: false,
    }
  },
  computed: {
    offerComponent() {
      switch (this.offer.type) {
        case 'show':
          return {
            name: 'offer-show',
            title: 'Show and Save',
            fullBody: true,
          }
        case 'coupon':
          return {
            name: 'offer-coupon',
            title: 'Coupon Code',
            fullBody: false,
          }
        default:
          return null
      }
    },
    isHTMLType() {
      return this.offer.type === 'html'
    },
  },
  methods: {
    formatDate(value) {
      return formatDate(value, 'DD MMMM YYYY')
    },
    redeemOffer() {
      if (!this.isOfferTypeUrl(this.offer.type)) {
        this.offerVisible = true
      } else {
        window.open(this.offer.promotionUrl, '_blank', 'noopener')
      }
    },
    isOfferHasLocation(locations) {
      return locations.filter(value => value).length > 0
    },
  },
}
</script>

<template>
  <div :class="$style.wrapper">
    <template v-if="isHTMLType">
      <div v-html="offer.description" />
    </template>
    <template v-else>
      <div><b>{{ offer.name || 'Offer Name' }}</b></div>
      <div
        :class="$style.desctiption"
        v-html="offer.description || 'Offer Description'"
      />
    </template>

    <div
      v-if="isOfferHasLocation(offer.locations)"
      :class="$style.locations"
    >
      <div>Participating locations:</div>
      <div
        v-for="(location, idx) in offer.locations"
        :key="idx"
      >
        {{ location.name }}
      </div>
    </div>
    <div
      v-if="offerHasVideo"
      :class="$style.video"
    >
      <video
        v-if="!isYoutubeVideo"
        width="300"
        height="200"
        preload="auto"
        controls
      >
        <source
          :src="videoLink"
          type="video/mp4"
          codecs="avc1.42E01E, mp4a.40.2"
        >
      </video>
      <iframe
        v-else
        width="300"
        height="200"
        :src="videoLink"
        frameBorder="0"
        allowFullScreen
        title="Stream"
      />
    </div>

    <div
      v-if="offer.startsAt"
      :class="$style.offerEnds"
    >
      Starts {{ formatDate(offer.startsAt) }}
    </div>

    <div
      v-if="offer.endsAt"
      :class="$style.offerEnds"
    >
      Ends {{ formatDate(offer.endsAt) }}
    </div>

    <div :class="$style.footer">
      <div
        v-if="offer.terms"
        :class="$style.terms"
        @click="termsVisible = true"
      >
        <b>View Offer Terms</b>
      </div>
      <div>
        <el-button
          v-if="!isHTMLType"
          type="primary"
          size="small"
          @click="redeemOffer"
        >
          Redeem
        </el-button>
      </div>
    </div>

    <preview-modal
      title="Terms and Conditions"
      :visible.sync="termsVisible"
      modal-append-to-body
      append-to-body
    >
      <div v-html="offer.terms" />
      <div slot="footer">
        <el-button
          type="primary"
          @click="termsVisible = false"
        >
          Got it
        </el-button>
      </div>
    </preview-modal>

    <preview-modal
      v-if="offerComponent"
      :title="offerComponent.title"
      :visible.sync="offerVisible"
      :full-body="offerComponent.fullBody"
    >
      <component
        :is="offerComponent.name"
        :offer="offer"
      />
    </preview-modal>
  </div>
</template>

<style lang="scss" module>
  .wrapper {
    width: 100%;
    word-break: break-all;
  }

  .desctiption,
  .locations,
  .offerEnds {
    margin-top: rem(10px);
    font-size: rem(14px);
  }

  .locations, .offerEnds {
    line-height: 1.1rem;
    color: var(--color-dark-gray);
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: rem(10px);

    div:only-child {
      margin-left: auto;
    }
  }

  .terms {
    font-size: rem(14px);
    color: var(--color-link);
    text-decoration: underline;
    cursor: pointer;
  }
  .video {
    pointer-events: auto;
    display: flex;
    justify-content: center;
    margin-bottom: 3rem;
    margin-top: 3rem;
    & video,
      iframe {
      border-radius: 10px;
      background-color: gray;
    }
  }
</style>
